export default "__VITE_ASSET__P6Xl3QuG__"